module.exports = __webpack_public_path__ + "img/stripe.a638d9f8.svg";